<!--
 功能名称:千里眼平台(技师)-数据同步时间
 开发人:梁高权
 创建时间:2021/04/08
 最后修改时间:2021/04/08
-->
<template>
  <div class="synchronizeTime-wrap">
    数据同步时间：{{technician.synchronize_time.replace(/-/g,".")}}
  </div>
</template>

<script>
import { mapState} from 'vuex'
export default{
  name:'synchronizeTime',
  computed: {...mapState(['technician'])}
}
</script>

<style lang="scss" scoped>
.synchronizeTime-wrap{
  text-align: center;
  color: rgba(255,255,255,.5);
  font-weight: 500;
  font-size: 22px;
}
</style>
